import { render, staticRenderFns } from "./Referents.vue?vue&type=template&id=00fa6074"
import script from "./Referents.vue?vue&type=script&lang=js"
export * from "./Referents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports